import React, { useEffect, useRef } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledAboutSection = styled.section`
  max-width: 900px;

  .inner {
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-gap: 50px;

    @media (max-width: 768px) {
      display: block;
    }
  }
`;
const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(140px, 200px));
    grid-gap: 0 10px;
    padding: 0;
    margin: 20px 0 0 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      margin-bottom: 10px;
      padding-left: 20px;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
const StyledPic = styled.div`
  position: relative;
  max-width: 300px;

  @media (max-width: 768px) {
    margin: 50px auto 0;
    width: 70%;
  }

  .wrapper {
    ${({ theme }) => theme.mixins.boxShadow};
    display: block;
    position: relative;
    width: 100%;
    border-radius: var(--border-radius);
    background-color: var(--green);

    &:hover,
    &:focus {
      outline: 0;
      transform: translate(-4px, -4px);

      &:after {
        transform: translate(8px, 8px);
      }

      .img {
        filter: none;
        mix-blend-mode: normal;
      }
    }

    .img {
      position: relative;
      border-radius: var(--border-radius);
      mix-blend-mode: multiply;
      filter: grayscale(100%) contrast(1);
      transition: var(--transition);
    }

    &:before,
    &:after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: var(--border-radius);
      transition: var(--transition);
    }

    &:before {
      top: 0;
      left: 0;
      background-color: var(--pink);
      mix-blend-mode: screen;
    }

    &:after {
      border: 2px solid var(--green);
      top: 14px;
      left: 14px;
      z-index: -1;
    }
  }
`;

const About = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  const skills = [
    'Satellite Remote Sensing',
    'Water Resources Management',
    'Irrigation',
    'Evapotranspiration',
    'Climate',
    'Hydrological Modelling',
    'Networks in Water Resources Management',
    'Cloud Computing',
  ];

  // const education = ['Ph.D in Civil and Environmental Engineering, University of Washington, 2025 (expected)',
  //   'M.S. in Civil and Environmental Engineering, University of Washington, 2022',
  //   'B.Tech. in Civil Engineering (Honors), IIT Gandhinagar, 2021'];

  return (
    <StyledAboutSection id="about" ref={revealContainer}>
      <h2 className="numbered-heading">About Me</h2>

      <div className="inner">
        <StyledText>
          <div>
            <p>
              I study Earth's surface water resources and explore sustainable, and efficient ways in
              the applications of these water resources. My work leverages satellite remote sensing
              and modeling to develop practical tools that bridge the gap between research and
              real-world applications!
            </p>
            <p>
              <strong>Education</strong>
              <ul>
                <li>
                  <p>
                    Ph.D in Civil and Environmental Engineering, University of Washington, 2025 ({' '}
                    <a href="/phd_defense.pdf" target="_blank" rel="noreferrer">
                      Link to my PhD Defense PPT
                    </a>{' '}
                    )
                  </p>
                </li>
                <li>M.S. in Civil and Environmental Engineering, University of Washington, 2022</li>
                <li>B.Tech. in Civil Engineering (Honors), IIT Gandhinagar, 2021</li>
              </ul>
              {/* <ul className="skills-list">
              {education && education.map((edu, i) => <li key={i}>{edu}</li>)}
              </ul> */}
            </p>
            <p>Here are a few topics that interests me:</p>
          </div>

          <ul className="skills-list">
            {skills && skills.map((skill, i) => <li key={i}>{skill}</li>)}
          </ul>
        </StyledText>

        <StyledPic>
          <div className="wrapper">
            <StaticImage
              className="img"
              src="../../images/me.jpg"
              width={500}
              quality={95}
              formats={['AUTO', 'WEBP', 'AVIF']}
              alt="Headshot"
            />
          </div>
        </StyledPic>
      </div>
    </StyledAboutSection>
  );
};

export default About;
